import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [subjects, setSubject] = useState('')
    const [massage, setMassage] = useState('')

    const sendMail = async () => {

        const res = await fetch('/home/sendMail', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ name, email, subjects, massage })
        });

        const data = await res.json();


        if (data.data === "Success") {
            toast.success('Email send successfully', {
                position: toast.POSITION.BOTTOM_RIGHT
            });

        }

    }

    return (
        <>

            <div className='container-fluid' style={{ margin: '1rem auto', width: '70%', color: 'black' }}>

                <div className='row'>
                    <div className='col-12' style={{ lineHeight: '2rem' }} >

                        <div style={{ textAlign: 'center', fontSize: '1.3rem' }}>Claim your problem</div>
                        <div class="form-group">
                            <label for="exampleFormControlInput1">Name </label>
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="email" class="form-control" id="exampleFormControlInput1" placeholder="Enter name" />
                        </div>

                        <div class="form-group">
                            <label for="exampleFormControlInput1">Email address</label>
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text" class="form-control" id="exampleFormControlInput1" placeholder="enter email" />
                        </div>

                        <div class="form-group">
                            <label for="exampleFormControlInput1">subject</label>
                            <input
                                onChange={(e) => setSubject(e.target.value)}
                                type="email" class="form-control" id="exampleFormControlInput1" placeholder="enter subject" />
                        </div>


                        <div class="form-group">
                            <label for="exampleFormControlTextarea1">Massage</label>
                            <textarea class="form-control"
                                onChange={(e) => setMassage(e.target.value)}
                                id="exampleFormControlTextarea1" rows="3"
                                placeholder='start writting....'
                            ></textarea>
                        </div>
                        <br />

                        <button
                            onClick={sendMail}
                            className='btn btn-success'>Send</button>
                        <ToastContainer />
                    </div>

                </div>
            </div>
        </>
    )
}

export default Contact;